function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import iconfontList from './iconfontList.js';
export default {
  name: 'BasicSetting',
  props: {
    tabName: {
      type: String,
      default: ''
    },
    conf: {
      type: Object,
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      grid1: {
        xl: 8,
        lg: 6,
        md: 2,
        sm: 24,
        xs: 24
      },
      grid2: {
        xl: 8,
        lg: 12,
        md: 20,
        sm: 24,
        xs: 24
      },
      visible: false,
      selectedIcon: '',
      selectedColor: '',
      examineFrom: {
        name: '',
        icon: '',
        info: '',
        color: ''
      },
      rules: {
        name: [{
          required: true,
          message: this.$t('business.message1'),
          trigger: 'blur'
        }],
        icon: [{
          required: true,
          message: this.$t('business.message2'),
          trigger: 'change'
        }]
      },
      iconList: iconfontList
    };
  },
  computed: {},
  created: function created() {
    if (_typeof(this.conf) === 'object' && this.conf !== null) {
      Object.assign(this.examineFrom, this.conf);
    }
  },
  methods: {
    // 给父级页面提供得获取本页数据得方法
    getData: function getData() {
      var _this = this;
      return new Promise(function (resolve, reject) {
        _this.$refs['elForm'].validate(function (valid) {
          if (!valid) {
            reject({
              target: _this.tabName
            });
            return;
          }
          resolve({
            examineFrom: _this.examineFrom,
            target: _this.tabName
          });
        });
      });
    },
    itemChose: function itemChose(row) {
      this.examineFrom.icon = row.icon;
      this.examineFrom.color = row.color;
      this.resetForm('elForm', 'icon');
      this.$refs.iconPopover.doClose();
    },
    handleIcon: function handleIcon() {
      this.$refs.iconPopover.doShow();
    },
    resetForm: function resetForm(formName, props) {
      this.$refs[formName].validateField(props);
    }
  }
};